import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@environments/environment';

// Initialize Segment Analytics with environment-specific write key and optional proxy
declare const analytics: any;

if (environment.segmentProxyEnabled) {
  // Proxy enabled: Use custom CDN and API endpoints
  const cdnUrl = `${window.location.origin}${environment.segmentCdnPath}`;
  const apiHost = `${window.location.host}${environment.segmentApiPath}/v1`;

  analytics.load(environment.segmentWriteKey, {
    cdnUrl: cdnUrl,
    integrations: {
      'Segment.io': {
        apiHost: apiHost,
        protocol: 'https'
      }
    }
  });
} else {
  // Proxy disabled: Use default Segment endpoints (explicitly override source-level config)
  analytics.load(environment.segmentWriteKey, {
    integrations: {
      'Segment.io': {
        apiHost: 'api.segment.io/v1',
        protocol: 'https'
      }
    }
  });
}

analytics.page();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
